import { BaseModel } from "sjs-base-model";

export default class SpeseIstruttoriaFormModel extends BaseModel {
    public readonly preliminaryCostsPercentage: string = "";
    public readonly preliminaryCostsAmount: string = "";
    public readonly minValue: number = 0;
    public readonly maxValue: number = 0;

    constructor(data: Partial<SpeseIstruttoriaFormModel>) {
        super();

        this.update(data);
    }
}
